import React, { useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField
} from '@mui/material';
import supabase from '../../../supabaseClient';

const pad = n => String(n).padStart(2, '0');
function AddPaymentModal({ open, onClose, employee, idConfig, onRefresh }) {
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [date, setDate] = useState('');

  const handleSave = async () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      alert('Podaj prawidłową kwotę!');
      return;
    }
    if (!date) {
      alert('Wybierz datę wypłaty');
      return;
    }
    const { error } = await supabase.from('payments').insert({
      employee_id: employee.id,
      amount: Number(amount),
      date,
      note,
      id_configuration: idConfig,
    });
    if (error) {
      console.log(error);
      alert('Błąd zapisu: ' + error.message);
    } else {
      setAmount('');
      setNote('');
      setDate('');
      onRefresh();
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Dodaj zaliczkę — {employee?.name} {employee?.surname}</DialogTitle>
      <DialogContent>
        <TextField label="Kwota (zł)" type="number" fullWidth value={amount}
          onChange={e => setAmount(e.target.value)} sx={{ mt: 2 }} />
        <TextField label="Notatka" fullWidth value={note}
          onChange={e => setNote(e.target.value)} sx={{ mt: 2 }} />
        <TextField
          label="Data wypłaty"
          type="date"
          fullWidth
          value={date}
          onChange={e => setDate(e.target.value)}
          onClick={e => e.target.showPicker?.()}
          InputLabelProps={{ shrink: true }}
          sx={{
            mt: 2,
            '& input:not([value=""])::-webkit-datetime-edit': { opacity: 1 },
            '& input[value=""]::-webkit-datetime-edit': { opacity: 0 },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anuluj</Button>
        <Button variant="contained" onClick={handleSave}>Zapisz</Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddPaymentModal;
